<template>
  <!--begin::Forgot-->
  <div class="login-form">
    <!--begin::Form-->
    <form class="form" novalidate="novalidate" id="kt_login_forgot_form">
      <!--begin::Title-->
      <div class="pb-13 pt-lg-0 pt-5">
        <h3 class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg">{{$t('AUTH.FORGOT.TITLE')}}</h3>
        <p class="text-muted font-weight-bold font-size-h4">{{$t('AUTH.FORGOT.DESC')}}</p>
      </div>
      <!--end::Title-->
      <!--begin::Form group-->
      <div class="form-group">
        <input class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6" v-model="email" type="email" placeholder="Email" name="email" autocomplete="off" />
      </div>
      <!--end::Form group-->
      <!--begin::Form group-->
      <div class="form-group d-flex flex-wrap pb-lg-0">
        <button type="button" class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-4" v-on:click="openInitPassWord">{{$t('AUTH.FORGOT.SUBMIT_BUTTON')}}</button>
        <button type="button" v-on:click="toLogin" class="btn btn-light-primary font-weight-bolder font-size-h6 px-8 py-4 my-3">{{$t('AUTH.FORGOT.CANCEL_BUTTON')}}</button>
      </div>
      <!--end::Form group-->
    </form>
    <!--end::Form-->
    <b-modal ref="initPassWord" hide-footer  size="xl">
      <template v-slot:modal-header="{ close }">
        <h5>{{$t('AUTH.FORGOT.DESC')}}</h5>
        <b-button size="sm" variant="outline-danger" @click="close()">
          {{$t('CRAFTVALUE.Close')}}
        </b-button>
      </template>
      <div class="form-group">
        <input class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6" v-model="email" type="email" placeholder="Email" name="email" autocomplete="off" />
      </div>
      <div class="form-group d-flex flex-wrap pb-lg-0">
        <button type="button" class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-4">{{$t('AUTH.FORGOT.CONFIRM_BUTTON')}}</button>
        <button type="button" class="btn btn-light-primary font-weight-bolder font-size-h6 px-8 py-4 my-3">{{$t('AUTH.FORGOT.CANCEL_BUTTON')}}</button>
      </div>
    </b-modal>
  </div>

  <!--end::Forgot-->
</template>
<script>
import axios from "@/core/services";
import router from "@/router";

export default {
  data(){
    return{
      email:''
    }
  },
  computed: {
    user: {
      get () {return this.$store.getters.currentUser;}
    }
  },
  methods: {
    toLogin(){
      this.$router.push("/login");
    },
    getInitPassWord()
    {
      if(!this.email)
      {
        alert(this.$t('ONLINE.Please_enter_email'));
      }
      const obj = {};
      obj.email = this.email;
      obj.defaultDb = this.user.defaultDb;
      axios.fetchPost("", obj).then(result => {
        if(result.data.result == "success"){
          alert(this.$t('ONLINE.Reset_password_successfully'))
          router.push("/");
        }else{
          alert(this.$t('ONLINE.Failed_to_reset_password'))
        }
        this.clickFlag = true;
      }).catch(err => {console.log(err);});
    },
    openInitPassWord(){
      this.$refs['initPassWord'].show()
    }
  }
}
</script>